import _styled from "styled-components";
import Box from "../../../Styled/Box";
import { useViewState } from "../../Context";
import { MapCredits } from "./Credits";
import { DistanceLegend } from "./DistanceLegend";
import { LocationBar } from "./LocationBar";
import { useTheme } from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BottomBar = () => {
  var _viewState$terria$con;
  const viewState = useViewState();
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(_StyledBox, {
    fullWidth: true,
    justifySpaceBetween: true,
    $_css: theme.transparentDark,
    $_css2: theme.blur,
    children: [/*#__PURE__*/_jsx(MapCredits, {
      hideTerriaLogo: !!viewState.terria.configParameters.hideTerriaLogo,
      credits: (_viewState$terria$con = viewState.terria.configParameters.extraCreditLinks) === null || _viewState$terria$con === void 0 ? void 0 : _viewState$terria$con.slice(),
      currentViewer: viewState.terria.mainViewer.currentViewer,
      searchBarModel: viewState.terria.searchBarModel
    }), /*#__PURE__*/_jsxs(Box, {
      paddedHorizontally: 4,
      gap: 2,
      children: [/*#__PURE__*/_jsx(LocationBar, {
        mouseCoords: viewState.terria.currentViewer.mouseCoords
      }), /*#__PURE__*/_jsx(DistanceLegend, {})]
    })]
  });
};
var _StyledBox = _styled(Box).withConfig({
  displayName: "BottomBar___StyledBox",
  componentId: "sc-vnnl1f-0"
})(["background:", ";backdrop-filter:", ";font-size:0.7rem;"], p => p.$_css, p => p.$_css2);